"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const ChartWrapper_1 = __importStar(require("../../components/ChartWrapper"));
const Footnotes_1 = require("../../components/Footnotes");
const Sources_1 = require("../../components/Sources");
const utilities_1 = require("../../utilities");
const constants_1 = require("../../utilities/constants");
const date_1 = require("../../utilities/date");
const types_1 = require("../../utilities/types");
const Bar_1 = __importDefault(require("./Bar"));
const constants_2 = require("./constants");
const helpers_1 = require("./helpers");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const MIN_HEIGHT = 150;
const GroupedBars = _ref => {
  let {
    axisTextColor = constants_1.AXIS_TEXT_COLOR,
    barHeight = constants_2.DEFAULT_BAR_HEIGHT,
    categories,
    data: rawData,
    floatingAxis = constants_2.DEFAULT_FLOATING_AXIS,
    fontSize = constants_2.DEFAULT_FONT_SIZE,
    gridColor = constants_1.AXIS_LINE_COLOR,
    groups,
    groupSpacing = constants_2.DEFAULT_GROUP_SPACING,
    height,
    hideAxis = constants_2.DEFAULT_HIDE_AXIS,
    hideFooter = constants_2.DEFAULT_HIDE_FOOTER,
    hideGridlines = constants_2.DEFAULT_HIDE_GRIDLINES,
    hideLegend = constants_2.DEFAULT_HIDE_LEGEND,
    hideSubtitle = constants_2.DEFAULT_HIDE_SUBTITLE,
    hideTitle = constants_2.DEFAULT_HIDE_TITLE,
    hideTooltip = constants_2.DEFAULT_HIDE_TOOLTIP,
    hideTooltipYear = constants_2.DEFAULT_HIDE_TOOLTIP_YEAR,
    hideValueLabel = constants_2.DEFAULT_HIDE_VALUE_LABEL,
    hideXTicks = constants_2.DEFAULT_HIDE_X_TICKS,
    hideYear = constants_2.DEFAULT_HIDE_YEAR,
    hideTopXTicks: rawHideTopXTicks = constants_2.DEFAULT_HIDE_TOP_X_TICKS,
    hideBottomXTicks: rawHideBottomXTicks = constants_2.DEFAULT_HIDE_BOTTOM_X_TICKS,
    metrics,
    selectedDate,
    sortDropdowns = constants_2.DEFAULT_DROPDOWN_SORT,
    subtitle,
    subtitleFontSize = constants_2.DEFAULT_SUBTITLE_FONT_SIZE,
    title,
    titleFontSize = constants_2.DEFAULT_TITLE_FONT_SIZE,
    width,
    xAxisTicks
  } = _ref;
  if (height !== 'auto' && height < MIN_HEIGHT) {
    console.warn(`Height cannot be lower than ${MIN_HEIGHT}.`);
  }
  let hideTopXTicks = rawHideTopXTicks;
  let hideBottomXTicks = rawHideBottomXTicks;
  if (hideXTicks) {
    hideTopXTicks = true;
    hideBottomXTicks = true;
  }
  const dataIdsString = (0, utilities_1.getDataIds)(rawData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = (0, react_1.useMemo)(() => (0, utilities_1.extractDatasets)(rawData), [dataIdsString]);
  /** Start Axis Setup */
  const dropdownFormat = (0, react_1.useMemo)(() => (0, utilities_1.valueFormat)({
    params: {
      format: (0, utilities_1.getAxisTypeFromData)(data, 'x') || constants_2.DEFAULT_DROPDOWN_TYPE
    }
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString]);
  const keys = (0, react_1.useMemo)(() => (0, utilities_1.extractKeys)(data, date_1.dateParser).map(i => ({
    ...i,
    parsed: dropdownFormat(i.key)
  })),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString]);
  const {
    key: date,
    dropdown
  } = (0, utilities_1.useDropdown)({
    enabled: true,
    keys,
    label: title ? ' ' : '',
    parser: dropdownFormat,
    sortBy: sortDropdowns,
    targetKey: selectedDate
  });
  const [tooltip, setTooltip] = (0, react_1.useState)({
    position: {
      x: null,
      y: null
    },
    group: null,
    category: null,
    value: null,
    color: null,
    y_type: null,
    direction: 'below'
  });
  const throttledSetTooltip = (0, react_1.useMemo)(() => lodash_1.default.debounce(newTooltip => {
    setTooltip(newTooltip);
  }, 33), []);
  let dropdowns = !hideYear && dropdown ? [dropdown] : [];
  const groupsIdKeys = (0, helpers_1.getIdKeyPair)(groups).join(',');
  const categoriesIdKeys = (0, helpers_1.getIdKeyPair)(categories).join(',');
  const selectedKeys = (0, react_1.useMemo)(() => {
    try {
      return (0, helpers_1.getSelectedKeys)({
        data,
        groups,
        categories
      });
    } catch (err) {
      console.warn(err.message);
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataIdsString, groupsIdKeys, categoriesIdKeys]);
  if (selectedKeys === null) {
    return react_1.default.createElement("div", null);
  }
  if (selectedKeys.length) {
    console.warn('Dropdowns are disabled when selecting keys from groups/categories.');
    dropdowns = [];
  }
  let footerSources = [];
  let footerSummary;
  let footnotes = [];
  if (!hideFooter) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const sources = (0, Sources_1.useSources)({
      data
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const footerFootnotes = (0, Footnotes_1.useFootnotes)({
      data
    });
    footerSources = sources.sources;
    footerSummary = sources.summary;
    footnotes = footerFootnotes.footnotes;
  }
  return react_1.default.createElement(ChartWrapper_1.default, {
    className: styles_module_css_1.default['grouped-bars'],
    title: hideTitle ? null : title,
    subtitle: hideSubtitle ? null : subtitle,
    titleFontSize: titleFontSize,
    subtitleFontSize: subtitleFontSize,
    footerSources: footerSources,
    footerSummary: footerSummary,
    footnotes: footnotes,
    showFooter: !hideFooter,
    showMetricFootnotes: false,
    dropdowns: dropdowns,
    width: width,
    height: height,
    fontSize: fontSize
  }, _ref2 => {
    let {
      chartWidth,
      chartHeight
    } = _ref2;
    return react_1.default.createElement(Bar_1.default, {
      ...{
        axisTextColor,
        barHeight,
        categories,
        data,
        date,
        floatingAxis,
        fontSize,
        gridColor,
        groups,
        groupSpacing,
        hideAxis,
        hideBottomXTicks,
        hideGridlines,
        hideLegend,
        hideTooltip,
        hideTooltipYear,
        hideTopXTicks,
        hideValueLabel,
        metrics,
        selectedKeys,
        throttledSetTooltip,
        tooltip,
        xAxisTicks
      },
      chartHeight: chartHeight,
      chartWidth: chartWidth,
      height: height,
      width: width
    });
  });
};
GroupedBars.propTypes = {
  ...ChartWrapper_1.chartWrapperPropTypes,
  /**
   * Height to draw the chart. Will be bassed off bar height if unset.
   */
  height: prop_types_1.number,
  /**
   * Width to draw the chart. Will fill container if unset.
   */
  width: prop_types_1.number,
  /*
   * Height of the bars in pixels
   */
  barHeight: prop_types_1.number,
  /**
   * IDs and labels of groups
   */
  groups: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired,
    key: prop_types_1.string
  })).isRequired,
  /**
   * IDs, labels and colors of categories
   */
  categories: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired,
    color: prop_types_1.string,
    key: prop_types_1.string
  })),
  /**
   * Defines which group and category each data belongs to. Allows override of name and color.
   */
  metrics: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    group: prop_types_1.string.isRequired,
    category: prop_types_1.string.isRequired,
    metrics: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      name: prop_types_1.string,
      id: prop_types_1.string.isRequired,
      color: prop_types_1.string
    }))
  })).isRequired,
  /**
   * Data for the chart
   */
  data: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /**
   * Removes the footer
   */
  hideFooter: prop_types_1.bool,
  /**
   * Removes the legend
   */
  hideLegend: prop_types_1.bool,
  /**
   * Removes the year dropdown menu
   */
  hideYear: prop_types_1.bool,
  /*
   * Default displayed year
   */
  selectedDate: prop_types_1.string,
  /**
   * Changes chart scaling so the maximum bar from each date is full width.
   */
  floatingAxis: prop_types_1.bool,
  /**
   * Removes value labels from the end of bars
   */
  hideValueLabel: prop_types_1.bool,
  /**
   * Removes the axis labels and gridlines
   */
  hideAxis: prop_types_1.bool,
  /**
   * Removes the axis gridlines
   */
  hideGridlines: prop_types_1.bool,
  /**
   * Specifies the desired number of gridlines. d3 will then modify this value
   * to make the lines look nice.
   */
  xAxisTicks: prop_types_1.number,
  /**
   * Prevents any tooltips from appearing
   */
  hideTooltip: prop_types_1.bool,
  /**
   * Changes the labels above and below the axis gridlines to the specified color.
   */
  axisTextColor: prop_types_1.string,
  /**
   * Hides the chart title and removes the year selection dropdown
   */
  hideTitle: prop_types_1.bool,
  /**
   * Hides the chart subtitle
   */
  hideSubtitle: prop_types_1.bool,
  /**
   * Changes the axis gridlines to the specified color
   */
  gridColor: prop_types_1.string,
  /**
   * Removes all axis labels
   */
  hideXTicks: prop_types_1.bool,
  /**
   * Removes bottom axis labels
   */
  hideBottomXTicks: prop_types_1.bool,
  /**
   * Removes top axis labels
   */
  hideTopXTicks: prop_types_1.bool,
  /**
   * Hides the year from all tooltips
   */
  hideTooltipYear: prop_types_1.bool,
  /**
   * sets default font size for chart body elements and footer
   */
  fontSize: prop_types_1.number,
  /*
   * sets spacing between bar groups
   */
  groupSpacing: prop_types_1.number,
  /**
   * Duration (in ms) of transitions
   */
  transitionDuration: prop_types_1.number,
  /**
   * Sort dropdown values
   */
  sortDropdowns: (0, prop_types_1.oneOf)(['ascending', 'descending', true, false])
};
exports.default = GroupedBars;